import { matchValues } from '@shared/core/types/common';

const currencies: OLO.Types.CURRENCY_SYMBOL[] = ['USD', 'PLN', 'EUR', 'AUD'];

export const currenciesType = matchValues(...currencies);
